import React from 'react';
import {BootstrapForm, FormGroup} from '../bootstrap/Form';
import Assert from '../../assert/Assert';

var getDefaultUserRoleId = (userRoles) => {
    if(userRoles.length == 1) {
        return userRoles[0].id;
    }

    return 3;
};

export default class UserForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputs: {
                email: {
                    value: '',
                    validators: [{
                        rule: Assert.minLength(1),
                        errorMessage: 'Please enter an email address'
                    }]
                },
                userRoleId : {
                    value: getDefaultUserRoleId(props.userRoles),
                    validators: [{
                        rule: Assert.isNumber,
                        errorMessage: 'Please enter a user role'
                    }]
                }
            },
            errors: {}
        };
    }

    handleSubmit(e) {
        e.preventDefault();

        if(this.isValid()) {
            this.props.onSubmit(this.getFormData());
        }
    }
    isValid() {
        var isValid = this.refs.form.isValid();
        if(! isValid) {
            this.setState({errors: this.refs.form.getErrors()});
        }
        return isValid;
    }
    getFormData() {
        return this.refs.form.getFormData();
    }
    handleChange(e) {
        var inputs = this.state.inputs;
        inputs[e.target.name].value = e.target.value;
        this.setState({inputs});
    }
    exposeFormData() {
        if(this.refs.form.isValid()) {
            this.props.onSubmit(
                this.refs.form.getFormData()
            );
        } else {
            this.setState({errors: this.refs.form.getErrors()});
        }
    }
    render() {
        return (
            <BootstrapForm ref="form" onSubmit={this.handleSubmit.bind(this)} inputs={this.state.inputs} className="form-horizontal">
                {this.props.userRoles.length > 1 &&
                    <FormGroup defaultText='Role'>
                        <select className="form-control"
                                name="userRoleId"
                                onChange={this.handleChange.bind(this)}
                                value={this.state.inputs.userRoleId.value}
                                style={{backgroundColor : '#eee'}}>
                            { this.props.userRoles.map((role,i) =>
                                    <option key={i} value={role.id}>{role.name}</option>
                            )}
                        </select>
                    </FormGroup>
                }
                <FormGroup defaultText='Login Email' errors={this.state.errors.email}> 
                        <input type="email"
                               name='email'
                               className="form-control"
                               onChange={this.handleChange.bind(this)}
                               value={this.state.inputs.email.value}
                               placeholder="Enter email" />
                </FormGroup>
            </BootstrapForm>
        );
    }
}




// WEBPACK FOOTER //
// ./app/components/user/UserForm.js